export function getUrlWithQuery(
  pathName: string,
  app: string | string[],
  params: { [name: string]: string | string[] } = {}
) {
  let query = {};
  if (app) {
    query["app"] = app;
  }
  for (let key in params) {
    query[key] = params[key];
  }

  if (Object.keys(query).length > 0) {
    return {
      pathname: pathName,
      query: query,
    };
  } else {
    return {
      pathname: pathName,
    };
  }
}

export const urlWithQuery = (
  path: string,
  app: string | string[],
  params: { [name: string]: string | string[] } = {}
) => {
  const p = new URLSearchParams();

  if (app && typeof app === "string" && app != "") {
    p.set("app", app);
  }
  if (app && Array.isArray(app)) {
    app.forEach((a) => p.append("app", a));
  }

  for (let key in params) {
    if (typeof params[key] === "string") {
      p.set(key, params[key] as string);
    }
    if (Array.isArray(params[key])) {
      (params[key] as string[]).forEach((v) => p.append(key, v));
    }
  }

  if (p.size === 0) {
    return path;
  } else {
    return `${path}?${p.toString()}`;
  }
};
